<div class="space-y-6">
  <section hlmCard>
    <div hlmCardHeader>
      <h2 hlmCardTitle>Gebührenrechnungen</h2>
      <p hlmCardDescription>
        Wähle einen oder mehrere Monate aus, um die Rechnungen herunterzuladen.
      </p>
      <div hlmCardAction>
        <hlm-native-select
          selectId="yearSelect"
          [(ngModel)]="selectedYear"
          (ngModelChange)="onYearChange()">
          @for (year of years; track year) {
            <option hlmNativeSelectOption [value]="year">{{ year }}</option>
          }
        </hlm-native-select>
      </div>
    </div>

    <div hlmCardContent class="space-y-4">
      <div hlmTableContainer>
        <table hlmTable>
          <thead hlmTHead>
            <tr hlmTr>
              <th hlmTh class="w-10"></th>
              <th hlmTh>Monat</th>
              <th hlmTh class="text-right">Gebühren</th>
              <th hlmTh class="text-right">Ausgegebener Gutscheinwert</th>
            </tr>
          </thead>
          <tbody hlmTBody>
            @for (month of months; track month.value) {
              <tr hlmTr [class.opacity-50]="!isSelectable(month.value)">
                <td hlmTd>
                  <hlm-checkbox
                    [checked]="selectedMonths.includes(month.value)"
                    [disabled]="!isSelectable(month.value)"
                    [attr.aria-label]="month.name + ' ' + selectedYear + ' auswählen'"
                    (checkedChange)="toggleMonth(month.value)" />
                </td>

                <td hlmTd>
                  <span class="font-medium">{{ month.name }} {{ selectedYear }}</span>
                  @if (
                    !hasMonthlyFees(month.value) &&
                    isMonthAvailable(month.value) &&
                    !hasOnlyInternalVouchers(month.value)
                  ) {
                    <span hlmMuted class="ms-1 text-xs">(keine Transaktionen)</span>
                  }
                  @if (hasOnlyInternalVouchers(month.value) && isMonthAvailable(month.value)) {
                    <span hlmMuted class="ms-1 text-xs">
                      (nur interne Gutscheine – nicht abrechenbar)
                    </span>
                  }
                </td>

                <td hlmTd class="text-right tabular-nums">
                  @if (getMonthlyFees(month.value); as fees) {
                    {{ fees.total_fees / 100 | number: '1.2-2' : 'de' }} €
                  } @else {
                    <span class="text-muted-foreground">–</span>
                  }
                </td>

                <td hlmTd class="text-right tabular-nums">
                  @if (getMonthlyFees(month.value); as fees) {
                    {{ fees.total_amount / 100 | number: '1.2-2' : 'de' }} €
                  } @else {
                    <span class="text-muted-foreground">–</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (downloadError) {
        <div hlmAlert variant="destructive">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>Fehler beim Herunterladen</p>
          <p hlmAlertDescription>{{ downloadError }}</p>
          @if (downloadError.includes('UST-ID')) {
            <a
              hlmBtn
              variant="outline"
              size="sm"
              class="mt-2"
              [routerLink]="['/settings']"
              [queryParams]="{ tab: 'company' }">
              UST-ID hinterlegen
            </a>
          }
        </div>
      }

      @if (downloadSuccess) {
        <div hlmAlert>
          <ng-icon name="lucideCircleCheck" />
          <p hlmAlertTitle>{{ downloadSuccess }}</p>
        </div>
      }
    </div>

    <div hlmCardFooter class="flex-col items-stretch gap-3 border-t pt-4">
      <button
        hlmBtn
        class="w-full"
        [disabled]="!canDownloadSelectedMonths() || isDownloading"
        (click)="downloadSelectedInvoices()">
        @if (isDownloading) {
          <hlm-spinner />
          Wird heruntergeladen…
        } @else if (selectedMonths.length > 0) {
          <ng-icon name="lucideDownload" />
          {{ selectedMonths.length }} Rechnung{{ selectedMonths.length !== 1 ? 'en' : '' }}
          herunterladen
        } @else {
          Bitte Monate auswählen
        }
      </button>

      <p hlmMuted class="text-center text-xs">
        Intern erstellte Gutscheine (z.&nbsp;B. für Verlosungen) sind gebührenfrei und daher nicht
        Teil dieser Abrechnung.
      </p>
    </div>
  </section>
</div>
